var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2061",
    style: {
      enableBackground: "new 0 0 3840 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zone_2_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00A3DE",
      strokeWidth: 41.9615,
      strokeMiterlimit: 10
    },
    d: "M3685.317,1380.539l1.559-112.891 c0.568-41.133-7.019-81.147-22.55-118.932c-14.98-36.443-36.656-69.197-64.426-97.354c-27.771-28.157-60.224-50.283-96.456-65.764 c-17.986-7.685-36.629-13.585-55.667-17.628V837.063c0-49.033-9.618-96.633-28.586-141.479 c-18.308-43.285-44.503-82.144-77.858-115.498c-33.354-33.354-72.213-59.55-115.498-77.858 c-44.845-18.968-92.446-28.586-141.48-28.586h-357.107V446c0-55.979-21.8-108.608-61.383-148.191 c-39.583-39.584-92.212-61.383-148.192-61.383l0,0h-601.112c-55.576,0-107.825,21.642-147.123,60.941 c-23.829,23.829-41.302,52.596-51.285,84.18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone2);
export default __webpack_public_path__ + "static/media/zone_2.3877a8a4.svg";
export { ForwardRef as ReactComponent };